import { Chip } from "@mui/material";

import { CabinsColors } from "@/constants/config";
import { FlightItem } from "@/typings";

function toLowerCaseFirstLetter(str: string): string {
  if (!str) return str;
  return (str.charAt(0).toLowerCase() + str.slice(1)).replace(/\s+/g, "");
}

const CabinColorItem = (props: {
  data: FlightItem;
  type: keyof FlightItem["cabin_prices"];
  onClick: () => void;
  bank_name: string;
}) => {
  const { data, type } = props;
  const seats = data.cabin_prices[type].seats;
  return (
    <Chip
      className="w-[100%]"
      label={
        <div className="leading-tight">
          <div className="text-center">
            {data.cabin_prices[type]
              ? `${
                  props.bank_name && data.cabin_prices[type].transfer_options
                    ? data.cabin_prices[type].transfer_options
                        .filter((option) => option.program === props.bank_name)[0]
                        ?.points.toLocaleString()
                    : data.cabin_prices[type].miles.toLocaleString()
                } pts`
              : "Not Available"}
          </div>
          <div className="text-center pr-[5px]">
            {data.cabin_prices[type].tax > 0 && `+ ${data.cabin_prices[type].tax} • `}{" "}
            {seats == -1 || seats == undefined ? "" : ` ${seats + ""}`}
            {"+ Seats"}
          </div>
        </div>
      }
      sx={{
        borderRadius: 2,
        backgroundColor: CabinsColors[toLowerCaseFirstLetter(type)],
        fontWeight: 600,
        color: "white",
        ".MuiChip-icon": {
          color: "white",
        },
        height: "42px",
        "& .MuiChip-label": {
          display: "block",
          whiteSpace: "normal",
        },
      }}
    />
  );
};

export default CabinColorItem;
